import { SpotlightTable, SpotlightVisualGuidelines, SpotlightCollectionBackgroundColors } from '@af/design-system-docs-ui';
import { Stack } from '@atlaskit/primitives/compiled';
import Image from '@atlaskit/image';
import tourUseDo from "../../../../../../packages/design-system/spotlight/constellation/images/tour-use-do.png";
import tourUseDont from "../../../../../../packages/design-system/spotlight/constellation/images/tour-use-dont.png";
import singleStepLight from "../../../../../../packages/design-system/spotlight/constellation/images/single-step-light.png";
import singleStepDark from "../../../../../../packages/design-system/spotlight/constellation/images/single-step-dark.png";
import triggeredSpotlightLight from "../../../../../../packages/design-system/spotlight/constellation/images/triggered-spotlight-light.png";
import triggeredSpotlightDark from "../../../../../../packages/design-system/spotlight/constellation/images/triggered-spotlight-dark.png";
import principlesDoLight from "../../../../../../packages/design-system/spotlight/constellation/images/principles-of-use-do-light.png";
import principlesDoDark from "../../../../../../packages/design-system/spotlight/constellation/images/principles-of-use-do-dark.png";
import principlesDontLight from "../../../../../../packages/design-system/spotlight/constellation/images/principles-of-use-dont-light.png";
import principlesDontDark from "../../../../../../packages/design-system/spotlight/constellation/images/principles-of-use-dont-dark.png";
import spotlightAnatomyLight from "../../../../../../packages/design-system/spotlight/constellation/images/spotlight-anatomy-light.png";
import spotlightAnatomyDark from "../../../../../../packages/design-system/spotlight/constellation/images/spotlight-anatomy-dark.png";
import colorApplicationLight from "../../../../../../packages/design-system/spotlight/constellation/images/color-application-light.png";
import colorApplicationDark from "../../../../../../packages/design-system/spotlight/constellation/images/color-application-dark.png";
import * as React from 'react';
export default {
  SpotlightTable,
  SpotlightVisualGuidelines,
  SpotlightCollectionBackgroundColors,
  Stack,
  Image,
  tourUseDo,
  tourUseDont,
  singleStepLight,
  singleStepDark,
  triggeredSpotlightLight,
  triggeredSpotlightDark,
  principlesDoLight,
  principlesDoDark,
  principlesDontLight,
  principlesDontDark,
  spotlightAnatomyLight,
  spotlightAnatomyDark,
  colorApplicationLight,
  colorApplicationDark,
  React
};